import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { RoomRow } from './templates/RoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const FloorSensorRow = ({ manifold }: Props) => {
  return (
    <RoomRow
      name="Floor Sensor"
      manifold={manifold}
      getValue={room => (room.numberOfFloorSensors === 0 ? 'No' : 'Yes')}
    />
  );
};
